import { render, staticRenderFns } from "./performance-report.vue?vue&type=template&id=375fe1de"
import script from "./performance-report.vue?vue&type=script&lang=ts"
export * from "./performance-report.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports